import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { ManifestoIntro, ManifestoSlide, ManifestoEnd } from "@molecules";
import { ManifestoContainer } from "@organisms";

const ManifestoPage = ({ data }) => {
  const { title, intro, slides, outtro, meta} = data;

  return (
    <PageContainer manifesto meta={meta}>
      <ManifestoContainer
        intro={intro}
        end={outtro}
        slides={slides}
      />
    </PageContainer>
  );
};

ManifestoPage.defaultProps = {};

ManifestoPage.propTypes = {};

export default ManifestoPage;
